var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.6 116.438H137.531V104.625C137.531 103.228 136.397 102.094 135 102.094H101.25C92.3097 102.094 84.8391 108.198 82.6 116.438Z",
    fill: "#498CCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.75 102.094H27C25.6025 102.094 24.4688 103.228 24.4688 104.625V116.438H79.4C77.1609 108.198 69.6903 102.094 60.75 102.094Z",
    fill: "#498CCE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.75 121.5H20.25C18.8521 121.5 17.7188 122.633 17.7188 124.031V131.625C17.7188 133.023 18.8521 134.156 20.25 134.156H141.75C143.148 134.156 144.281 133.023 144.281 131.625V124.031C144.281 122.633 143.148 121.5 141.75 121.5Z",
    fill: "#498CCE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.98 66.6567H56.0204L66.1454 81.8442H95.8546L105.98 66.6567ZM81 76.7817C79.6021 76.7817 78.4688 75.6483 78.4688 74.2505C78.4688 72.8524 79.6021 71.7192 81 71.7192C82.3979 71.7192 83.5313 72.8524 83.5313 74.2505C83.5313 75.6483 82.3979 76.7817 81 76.7817Z",
    fill: "#498CCE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.625 97.0317H84.375C89.4935 97.0317 93.6562 92.869 93.6562 87.7505V86.9067H68.3438V87.7505C68.3438 92.869 72.5065 97.0317 77.625 97.0317Z",
    fill: "#498CCE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.028 61.5942C105.75 48.3556 94.5684 37.9692 81 37.9692C67.4316 37.9692 56.2499 48.3556 54.972 61.5942H107.028Z",
    fill: "#498CCE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.389 40.1479L113.138 31.8125C113.933 30.6623 113.643 29.0852 112.492 28.2925C111.339 27.4965 109.765 27.7866 108.972 28.9385L103.223 37.2738C102.428 38.4241 102.718 40.0012 103.869 40.7939C104.966 41.5502 106.586 41.3105 107.389 40.1479Z",
    fill: "#498CCE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.326 48.0412C109.755 49.3175 111.25 50.0712 112.53 49.6368L118.929 47.4912C120.256 47.0479 120.969 45.6125 120.524 44.2876C120.081 42.9609 118.646 42.2424 117.321 42.6923L110.922 44.838C109.595 45.2813 108.882 46.7162 109.326 48.0412Z",
    fill: "#498CCE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6114 40.1477C55.3637 41.2385 57.0364 41.5513 58.1314 40.7939C59.2817 40.0013 59.5717 38.4242 58.7774 37.2739L53.0277 28.9386C52.2351 27.7883 50.6613 27.4999 49.5077 28.2926C48.3574 29.0852 48.0674 30.6623 48.8617 31.8126C48.8617 31.8126 54.5904 40.1174 54.6114 40.1477Z",
    fill: "#498CCE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0708 47.4909L49.47 49.6365C50.7778 50.0804 52.2375 49.345 52.6734 48.0413C53.1184 46.7163 52.4048 45.281 51.0782 44.8377L44.6792 42.692C43.3542 42.2455 41.9205 42.9606 41.4756 44.2873C41.0306 45.6122 41.7442 47.0476 43.0708 47.4909Z",
    fill: "#498CCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducator);
export default __webpack_public_path__ + "static/media/Educator.6503db6c996e75f9b4349da5b34603a0.svg";
export { ForwardRef as ReactComponent };